/**
 * Billing refusals from the upload paths (the upload queue, mail attachments): an upload past the plan's storage pool
 * comes back 403 `plan_limit_storage`. The shell listens and hands it to BillingViewModel `noteFault`, which re-reads
 * the plan and opens the storage-full prompt.
 */
import { ApiFailure, StorageLimit } from "@bundle/core";

type Listener = (ws: string, code: StorageLimit.BillingFaultCode) => void;
const listeners = new Set<Listener>();

export function onBillingFault(listener: Listener): () => void {
  listeners.add(listener);
  return () => void listeners.delete(listener);
}

/** Reports `e` when it is a billing refusal (true), so callers can skip retrying it. */
export function reportBillingFault(ws: string, e: unknown): boolean {
  if (!(e instanceof ApiFailure)) return false;
  const code = StorageLimit.billingFault(e.code);
  if (code === null) return false;
  for (const l of Array.from(listeners)) l(ws, code);
  return true;
}
